// Services
import CFiltro from '../../base/CFiltro';

// Types
import type { TTypeDinamico } from '@/types/TTypeDinamico';
import type { TOperadoresAgregacao } from '@/shared/types/TOperadoresAgregacao';

export class CMetricaAgregacao<T> {
  operador: TOperadoresAgregacao = 'count';
  campo: TTypeDinamico<T> = '' as any;
  distinct?: boolean = true;

  constructor(pObj?: Partial<CMetricaAgregacao<T>>) {
    Object.assign(this, pObj);
  }
}

export default class CConsultaAgregacao<T extends Record<string, any>> {
  public codificacao: string = '';
  private _grupos: Array<TTypeDinamico<T>> = [];
  private _metricas: CMetricaAgregacao<T>[] = [];
  public query: CFiltro<T> = new CFiltro<T>();

  constructor(pObjeto?: {
    query?: CFiltro<T>;
    codificacao: string;
    grupos: Array<TTypeDinamico<T>>;
    metricas: CMetricaAgregacao<T>[];
  }) {
    if (!pObjeto) return;

    this.validarMetricas(pObjeto.metricas);

    this._grupos = pObjeto.grupos;

    this._metricas = pObjeto.metricas;
    this.codificacao = pObjeto.codificacao;

    if (pObjeto.query) {
      //this.query = pObjeto.query; // TODO
      this.query = Object.assign(new CFiltro<T>(), JSON.parse(JSON.stringify(pObjeto.query)));
      this.query.filtroFixo = pObjeto.query.filtroFixo;
    }
  }

  get grupos(): Array<TTypeDinamico<T>> {
    return this._grupos;
  }

  set grupos(pValor: Array<TTypeDinamico<T>>) {
    this._grupos = pValor;
  }

  get metricas(): CMetricaAgregacao<T>[] {
    return this._metricas;
  }

  set metricas(pValor: CMetricaAgregacao<T>[]) {
    this.validarMetricas(pValor);
    this._metricas = pValor;
  }

  // Método privado para validar se o operador é um valor permitido
  private validarMetricas(pMetricas: CMetricaAgregacao<T>[]) {
    //const operadoresPermitidos: Array<'sum' | 'avg' | 'max' | 'min'> = ['sum', 'avg', 'max', 'min'];
    // if (!operadoresPermitidos.includes(operador)) {
    //   throw new Error(`Operador inválido: ${operador}`)
    // }
  }

  /**
   * Converte a instância do modelo em um objeto.
   * @returns Um objeto que representa a instância do modelo.
   */
  toObject(): T {
    const obj = {} as T;

    // Itera sobre as propriedades da instância
    for (const key of Object.keys(this)) {
      const value = (this as any)[key];

      // Exclui propriedades que começam com "_" (se necessário)
      if (!key.startsWith('_')) {
        (obj as any)[key] = value;
      } else {
        // Remove o "_" inicial e adiciona ao objeto final
        (obj as any)[key.substring(1)] = value;
      }
    }

    return obj;
  }
}
